import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { AuthenticationContext } from '../../context/authentication-context';

import {
  LoginContainer,
  LoginButton,
  LoginFormSection,
  LoginIcon,
  LoginInputText,
  LoginMessage,
} from './style';

import NavbarSection from "../../components/pages/home/navbar-section";
import PageMeta from "../../components/common/page-meta";

import Lock from '../../assets/images/lock.svg';

import { loginWithEmailAndPassword } from '../../data/firebase';
import { useQuery } from '../../hooks';

const ENTER_KEY = 'Enter';

const Login = () => {
  const history = useHistory();
  const query = useQuery();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [ hasError, setError ] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const { isLoggedIn, isAuthenticationReady } = useContext(AuthenticationContext);

  const redirectUrl = query.get('redirectUrl') || '/';

  useEffect(() => {
    if (isAuthenticationReady && isLoggedIn) {
      history.replace(decodeURIComponent(redirectUrl));
    };
  }, [history, isAuthenticationReady, isLoggedIn, redirectUrl]);

  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key !== ENTER_KEY) {
      return;
    }
    submitLogin();
  };

  const onPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
    setError(false);
  };

  const onEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
    setError(false);
  };

  const submitLogin = async () => {
    if (!email.trim() || !password) {
      setError(true);
      return;
    }

    setSubmitting(true);
    setError(false);
    try {
      await loginWithEmailAndPassword(email, password);
    } catch (error) {
      setError(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <LoginContainer>
      <PageMeta
        title="Sign in — Freddy's"
        description="Sign in to manage Freddy's private writing."
      />
      <NavbarSection percentage={0} showLine={true}/>
      <LoginFormSection>
        <LoginIcon src={Lock} />
        <LoginInputText
          autoFocus
          hasError={hasError}
          type="email"
          value={email}
          placeholder="Admin email"
          autoComplete="email"
          onKeyDown={onKeyDown}
          onChange={onEmailChange}/>
        <LoginInputText
          hasError={hasError}
          type="password"
          value={password}
          placeholder="Password"
          autoComplete="current-password"
          onKeyDown={onKeyDown}
          onChange={onPasswordChange}/>
        <LoginButton
          type="button"
          disabled={isSubmitting}
          onClick={submitLogin}>
          {isSubmitting ? "Signing in…" : "Sign in"}
        </LoginButton>
        {hasError && (
          <LoginMessage>
            The email or password is incorrect, or the Firebase account has not
            been created yet.
          </LoginMessage>
        )}
      </LoginFormSection>
    </LoginContainer>
  )
}

export default Login
